import React from "react";
import SubHeading from "../atoms/SubHeading";

const NoData = ({ color }) => {
    return(
        <div className="w-full text-center">
            <SubHeading text="No hay datos disponibles" color={color ? color : "blue"}/>
        </div>
    )
};

export default NoData;